import RMDetails from '@components/reschedule-course-class/rm-details'
import { RelationshipManagerType } from '@lib/types/common'

type Props = {
  relationshipManager: RelationshipManagerType
}

const GroupClassRescheduleTooltipContent = ({ relationshipManager }: Props) => (
  <div className="w-64 p-1 flex flex-col space-y-2">
    <p className="leading-tight">
      You can&apos;t reschedule this class because it&apos;s a peer learning
      program. Contact RM for assistance.
    </p>
    <RMDetails relationshipManager={relationshipManager} />
  </div>
)

export default GroupClassRescheduleTooltipContent
